const baseRoute = process.env.REACT_APP_BACKEND_ADDRESS;

export const urls = {
  latestStatute: `${baseRoute}/statute/latest`,
};
